// extracted by mini-css-extract-plugin
export var clauseRow = "_dd-6";
export var emptyState = "_dd-d";
export var filterContent = "_dd-a";
export var filterGroup = "_dd-1";
export var filterGroupContainer = "_dd-0";
export var nestedGroup = "_dd-2";
export var nestedGroupContent = "_dd-b";
export var nestedGroupDepth1 = "_dd-3";
export var nestedGroupDepth2 = "_dd-4";
export var nestedGroupDepth3 = "_dd-5";
export var nestedGroupEmpty = "_dd-c";
export var operatorAnd = "_dd-8";
export var operatorOr = "_dd-9";
export var operatorToggle = "_dd-7";
export var removeGroupButton = "_dd-e";